import React, { useState } from 'react';
import Game1 from './Game1';
import Game2 from './Game2';
import Game3 from './Game3';
import './App.css';

export default function App() {
  const [currentLevel, setCurrentLevel] = useState(1);
  const [unlockedLevel, setUnlockedLevel] = useState(1);

  const handleUnlock = (level) => {
    if (level > unlockedLevel) setUnlockedLevel(level);
    setCurrentLevel(level);
  };

  const handleNav = (level) => {
    setCurrentLevel(level);
  };

  return (
    <div className="app-wrapper">
      <div className="app-title">🌈 Maths Magiques</div>
      {currentLevel === 1 && (
        <Game1
          onUnlock={handleUnlock}
          unlockedLevel={unlockedLevel}
          currentLevel={currentLevel}
          onNav={handleNav}
        />
      )}
      {currentLevel === 2 && (
        <Game2
          onUnlock={handleUnlock}
          unlockedLevel={unlockedLevel}
          currentLevel={currentLevel}
          onNav={handleNav}
        />
      )}
      {currentLevel === 3 && (
        <Game3
          onUnlock={handleUnlock}
          unlockedLevel={unlockedLevel}
          currentLevel={currentLevel}
          onNav={handleNav}
        />
      )}
    </div>
  );
}
